export const INHERENT_RISK_ICON_LABEL = {
  INHERENT_RISK: 'Inherent Risk',
  ESTIMATED_INHERENT_RISK: 'Estimated Inherent Risk',
} as const
